module.exports = __webpack_public_path__ + "static/img/home.ff879fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = P7rK
// module chunks = 0